import apiClient from '@/plugins/apiClient'
let basePath = "/account";

export default {
     namespaced: true,
     state:{
          account: localStorage.getItem('account'),
          errors: {},
          message: null,
     },
     getters:{
          account: state => (state.account) ? JSON.parse(state.account) : null,
          message: state => state.message,
          errors: state => state.errors,
     },
     mutations:{
          error(state, err) {
               state.errors = err.response.data
          },
          setAccount(state, resp){
               localStorage.setItem('account', JSON.stringify(resp.data))
               state.account = JSON.stringify(resp.data)
          }
     },
     actions:{
         
          getAccount({commit}){
               return new Promise((resolve, reject) => {
                    apiClient.get(basePath).then(resp => {
                         commit('setAccount', resp.data);
                         resolve(resp);
                     })
                     .catch(err => {
                         commit('error', err);
                         reject(err);
                     });
               })
          },
          
          updateAccount({commit},data){
               return new Promise((resolve, reject) => {
                    apiClient.patch(basePath+"/update", data).then(resp => {
                         resolve(resp);
                         commit('setAccount', resp.data);
                     })
                     .catch(err => {
                         commit('error', err);
                         reject(err);
                     });
               })
          },
     }
}